import { gql, type TypedDocumentNode } from '@apollo/client';
import { type IActivityListEntity } from './interfaces';

export const ACTIVITIES_QUERY: TypedDocumentNode<ActivitiesQueryData, ActivitiesQueryVars> = gql`
    query ACTIVITIES_QUERY($providerId: Long!) {
        activities(providerId: $providerId) {
            client {
                firstName
                lastName
                requestTypeId
            }
            organization {
                name
            }
            presentingIssue
            activityId
            caseId
            targetedSystem {
                systemCode
            }
            solutionCode
        }
    }
`

interface ActivitiesQueryData {
    activities: IActivityListEntity[]
}

interface ActivitiesQueryVars {
    providerId: number
}